// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout_wrapper__zoHNn {
  /* background: linear-gradient(192deg, #1b8067 0%, #08563d 100%); */
}
.layout_main__7lOAi {
  /* background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(/public/assets/layout/bg-mobile.png); */
}
.layout_header__hNzoz {
}
.layout_bg__INBkD {
  position: absolute;
  bottom: 0;
  z-index: -1;
}
.layout_bg__INBkD img {
  height: 354px;
}
@media screen and (min-width: 500px) {
  .layout_bg__INBkD img {
    height: 100%;
    width: 100%;
  }
  .layout_bg__INBkD {
    width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  /* .main {
    background-image: url(/public/assets/layout/bg-desktop.png);
  } */
}
`, "",{"version":3,"sources":["webpack://./src/pages/layout/layout.module.css"],"names":[],"mappings":"AAAA;EACE,mEAAmE;AACrE;AACA;EACE;;;+DAG6D;AAC/D;AACA;AACA;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;;KAEG;AACL","sourcesContent":[".wrapper {\n  /* background: linear-gradient(192deg, #1b8067 0%, #08563d 100%); */\n}\n.main {\n  /* background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(/public/assets/layout/bg-mobile.png); */\n}\n.header {\n}\n.bg {\n  position: absolute;\n  bottom: 0;\n  z-index: -1;\n}\n.bg img {\n  height: 354px;\n}\n@media screen and (min-width: 500px) {\n  .bg img {\n    height: 100%;\n    width: 100%;\n  }\n  .bg {\n    width: 100%;\n  }\n}\n@media screen and (min-width: 1200px) {\n  /* .main {\n    background-image: url(/public/assets/layout/bg-desktop.png);\n  } */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `layout_wrapper__zoHNn`,
	"main": `layout_main__7lOAi`,
	"header": `layout_header__hNzoz`,
	"bg": `layout_bg__INBkD`
};
export default ___CSS_LOADER_EXPORT___;
